import { JSX, useState } from "react";
import { useTranslation } from "react-i18next";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import { asTitle } from "utils/Utils";
import { Event } from "utils/history/Event";

import { Role } from "core/blueprint/trajectory/TrajectoryBlueprintService";
import { Field } from "core/field/FieldService";

import InformationRoleRow from "core/trajectory/access/InformationRoleRow";
import InformationSubHeader from "core/trajectory/access/InformationSubHeader";
import RoleInsertRow from "core/trajectory/access/RoleInsertRow";

export interface InformationRoleTableProps {
	roles: Role[];
	information: Field[];
	editable: boolean;

	isValid: (name: string) => boolean;
	onInsert: (role: Role) => void;
	onChange: (event: Event) => void;
	onDelete: (index: number) => void;
}

function InformationRoleTable(props: InformationRoleTableProps): JSX.Element {
	const { t } = useTranslation();

	const [selection, setSelection] = useState<string[]>([]);

	return (
		<>
			<InformationSubHeader
				fields={props.information}
				selection={selection}
				onSelect={setSelection}
			/>
			<Table size="small">
				<TableHead>
					<TableRow>
						<TableCell>{asTitle(t("role"))}</TableCell>
						<TableCell
							padding="checkbox"
							sx={{ minWidth: 100 }}
							align="center">
							{asTitle(t("edit"))}
						</TableCell>
						<TableCell
							padding="checkbox"
							sx={{ minWidth: 100 }}
							align="center">
							{asTitle(t("read"))}
						</TableCell>
						<TableCell
							padding="checkbox"
							sx={{ minWidth: 100 }}
							align="center">
							{asTitle(t("hidden"))}
						</TableCell>
						<TableCell sx={{ width: 60 }} padding="none" />
					</TableRow>
				</TableHead>
				<TableBody>
					{props.roles.map((role, index) => (
						<InformationRoleRow
							key={role.name}
							index={index}
							role={role}
							selected={selection}
							editable={props.editable}
							onChange={props.onChange}
							onDelete={props.onDelete}
						/>
					))}
					{props.editable && (
						<RoleInsertRow
							colSpan={3}
							isValid={props.isValid}
							onInsert={props.onInsert}
						/>
					)}
				</TableBody>
			</Table>
		</>
	);
}

export default InformationRoleTable;
